(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["teknotext-nav-mega"] && !Shopify.designMode) return;
  try {
    /* * Navigation: Megamenue auf dem Desktop, Schublade auf kleinen Schirmen. */
  (() => {
    const OFFEN_ATTRIBUT = 'tkMega';

    if (!customElements.get('teknotext-nav-mega')) {
      class TeknotextNavMega extends HTMLElement {
        connectedCallback() {
          /* Hier stand this.setAttribute('data-tk-js', ''). */
          this.addEventListener('pointerdown', this.merkeZeiger);
          this.addEventListener('click', this.beiKlick);
          this.addEventListener('keydown', this.beiTaste);
          this.addEventListener('focusout', this.beiFokusAus);

          for (const gruppe of this.querySelectorAll('[data-tk-gruppe]')) {
            gruppe.addEventListener('pointerenter', this.beiZeigerRein);
            gruppe.addEventListener('pointerleave', this.beiZeigerRaus);
          }

          document.addEventListener('keydown', this.beiEscape);
          document.addEventListener('pointerdown', this.beiKlickAussen);
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.beiEscape);
          document.removeEventListener('pointerdown', this.beiKlickAussen);
          this.allesSchliessen();
        }

        get ausloeser() {
          return this.querySelectorAll('[aria-controls][aria-expanded]');
        }

        merkeZeiger = (ereignis) => {
          this.letzterZeiger = ereignis.pointerType;
        };

        oeffnen(ausloeser) {
          for (const anderer of this.ausloeser) {
            if (anderer !== ausloeser) anderer.setAttribute('aria-expanded', 'false');
          }

          ausloeser.setAttribute('aria-expanded', 'true');
          document.body.dataset[OFFEN_ATTRIBUT] = 'offen';
        }

        allesSchliessen() {
          for (const ausloeser of this.ausloeser) {
            ausloeser.setAttribute('aria-expanded', 'false');
          }

          delete document.body.dataset[OFFEN_ATTRIBUT];
        }

        beiKlick = (ereignis) => {
          const ausloeser = ereignis.target.closest('[aria-controls][aria-expanded]');
          if (!ausloeser || !this.contains(ausloeser)) return;

          ereignis.preventDefault();

          /*
             Mausklick fuehrt zur Kategorie – das Panel hat der Zeiger schon geoeffnet.
             Tastatur (detail 0) und Touch klappen weiter auf und zu, sonst waeren die
             Unterpunkte dort nicht erreichbar.
          */
          const ziel = ausloeser.dataset.tkZiel;
          if (ziel && ereignis.detail > 0 && this.letzterZeiger === 'mouse') {
            window.location.href = ziel;
            return;
          }

          if (ausloeser.getAttribute('aria-expanded') === 'true') {
            this.allesSchliessen();
          } else {
            this.oeffnen(ausloeser);
          }
        };

        /*
           Escape schliesst und gibt den Fokus an den Ausloeser zurueck – auch wenn der
           Fokus tief im Panel steht.
        */
        beiTaste = (ereignis) => {
          if (ereignis.key !== 'Escape') return;

          const gruppe = ereignis.target.closest('[data-tk-gruppe]');
          if (!gruppe) return;

          const ausloeser = gruppe.querySelector('[aria-controls][aria-expanded]');
          this.allesSchliessen();
          if (ausloeser) ausloeser.focus();
        };

        /*
           Escape wirkt auch, wenn das Panel nur per Zeiger offen steht und der Fokus noch
           gar nicht darin liegt.
        */
        beiEscape = (ereignis) => {
          if (ereignis.key !== 'Escape') return;
          if (!document.body.dataset[OFFEN_ATTRIBUT]) return;
          if (this.contains(document.activeElement)) return;

          this.allesSchliessen();
        };

        beiFokusAus = (ereignis) => {
          if (ereignis.relatedTarget && this.contains(ereignis.relatedTarget)) return;
          this.allesSchliessen();
        };

        beiKlickAussen = (ereignis) => {
          if (!document.body.dataset[OFFEN_ATTRIBUT]) return;
          if (this.contains(ereignis.target)) return;

          this.allesSchliessen();
        };

        beiZeigerRein = (ereignis) => {
          if (ereignis.pointerType === 'touch') return;

          const ausloeser = ereignis.currentTarget.querySelector('[aria-controls][aria-expanded]');
          if (ausloeser) this.oeffnen(ausloeser);
        };

        beiZeigerRaus = (ereignis) => {
          if (ereignis.pointerType === 'touch') return;
          if (this.contains(document.activeElement)) return;

          this.allesSchliessen();
        };
      }

      customElements.define('teknotext-nav-mega', TeknotextNavMega);
    }

    if (!customElements.get('teknotext-nav-mobil')) {
      class TeknotextNavMobil extends HTMLElement {
        connectedCallback() {
          this.ausloeser = this.querySelector('[aria-haspopup="dialog"]');
          this.schublade = this.querySelector('dialog');

          this.addEventListener('click', this.beiKlick);
          this.schublade?.addEventListener('close', this.beiSchliessen);
        }

        disconnectedCallback() {
          this.schublade?.removeEventListener('close', this.beiSchliessen);
        }

        beiKlick = (ereignis) => {
          const knopf = ereignis.target.closest('button');
          if (!knopf) return;

          if (knopf === this.ausloeser) {
            this.oeffnen();
            return;
          }

          if (knopf.hasAttribute('aria-controls') && knopf.hasAttribute('aria-expanded')) {
            const bereich = this.querySelector(`#${CSS.escape(knopf.getAttribute('aria-controls'))}`);
            const istOffen = knopf.getAttribute('aria-expanded') === 'true';

            knopf.setAttribute('aria-expanded', String(!istOffen));
            if (bereich) bereich.hidden = istOffen;
            return;
          }

          /* Nur der Schliessen-Knopf schliesst. */
          if (knopf.classList.contains('tk-schublade__zu')) this.schublade?.close();
        };

        oeffnen() {
          if (!this.schublade) return;

          this.schublade.showModal();
          this.ausloeser?.setAttribute('aria-expanded', 'true');
        }

        /*
           Der Browser schliesst das dialog auch per Escape und per Backdrop. Deshalb haengt
           das Zuruecksetzen am close-Ereignis und nicht am Klick auf die Schaltflaeche.
        */
        beiSchliessen = () => {
          this.ausloeser?.setAttribute('aria-expanded', 'false');
          this.ausloeser?.focus();
        };
      }

      customElements.define('teknotext-nav-mobil', TeknotextNavMobil);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["teknotext-sortierreiter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('teknotext-sortierreiter')) return;

    /* Feldname im dataset und Richtung. */
    const SORTIERUNG = {
      beliebt: { feld: 'tkBeliebt', absteigend: false },
      angebot: { feld: 'tkAngebot', absteigend: true, zweitfeld: 'tkPreis' },
      neu: { feld: 'tkNeu', absteigend: true },
    };

    class TeknotextSortierreiter extends HTMLElement {
      connectedCallback() {
        this.knoepfe = Array.from(this.querySelectorAll('[data-tk-sortierung]'));
        this.meldung = this.querySelector('[data-tk-meldung]');

        /*
           Die Karten liegen nicht in diesem Block, sondern in der Liste derselben Sektion.
           Der gemeinsame Rahmen ist .shopify-section.
        */
        const sektion = this.closest('.shopify-section');
        this.zellen = sektion ? Array.from(sektion.querySelectorAll('[data-tk-beliebt]')) : [];
        this.liste = this.zellen.length ? this.zellen[0].parentElement : null;

        this.addEventListener('click', this.beiKlick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.beiKlick);
      }

      beiKlick = (ereignis) => {
        const knopf = ereignis.target.closest('[data-tk-sortierung]');
        if (!knopf || !this.knoepfe.includes(knopf)) return;

        for (const anderer of this.knoepfe) {
          anderer.setAttribute('aria-pressed', anderer === knopf ? 'true' : 'false');
        }

        this.sortieren(knopf.dataset.tkSortierung);
        this.melden(knopf);
      };

      /*
         Beide Bausteine der Ansage stehen schon uebersetzt im Markup: der Name der Gruppe
         ("Geraete sortieren") und die Beschriftung des Schalters.
      */
      melden(knopf) {
        if (!this.meldung) return;

        const text = `${this.getAttribute('aria-label')}: ${knopf.textContent.trim()}`;
        this.meldung.textContent = '';
        requestAnimationFrame(() => {
          this.meldung.textContent = text;
        });
      }

      sortieren(modus) {
        const regel = SORTIERUNG[modus];
        if (!regel || !this.liste) return;

        const sortiert = [...this.zellen].sort((a, b) => {
          const wertA = Number(a.dataset[regel.feld]);
          const wertB = Number(b.dataset[regel.feld]);
          if (wertA !== wertB) return regel.absteigend ? wertB - wertA : wertA - wertB;

          /*
             Gleichstand. Bei "Bestes Angebot" ist das der Normalfall, solange kein Geraet
             einen Streichpreis traegt – ohne Zweitschluessel waere der Knopf dann sichtbar
             wirkungslos.
          */
          if (!regel.zweitfeld) return 0;
          return Number(a.dataset[regel.zweitfeld]) - Number(b.dataset[regel.zweitfeld]);
        });

        /*
           Minimaler Umzug: naechsten erwarteten Platz gegen das dort stehende Kind
           vergleichen.
        */
        let erwartet = this.liste.firstElementChild;
        for (const zelle of sortiert) {
          if (zelle === erwartet) {
            erwartet = erwartet.nextElementSibling;
          } else {
            this.liste.insertBefore(zelle, erwartet);
          }
        }
      }
    }

    customElements.define('teknotext-sortierreiter', TeknotextSortierreiter);
  })();
  } catch(e) { console.error(e); }
})();

})();
